import { unix } from "dayjs"
import { html, LitElement } from "lit"
import { customElement, property } from "lit/decorators.js"

@customElement("relative-timestamp")
class RelativeTimestamp extends LitElement {
  @property({type: Number})
  time: number

  render() {
    return html`${unix(this.time).fromNow()}`
  }
}